import { render, staticRenderFns } from "./fullReports.vue?vue&type=template&id=79fb5340"
import script from "./fullReports.vue?vue&type=script&lang=js"
export * from "./fullReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports